export const mapTableFlowImportedRows = (
  rows,
  columns,
  schema,
  identifierColumnId
) => {
  const columnMapById = new Map(columns.map((c) => [c.id, c]));

  const mappedRows = rows.map(({ values }, i) => {
    const valuesMap = new Map(Object.entries(values));
    const row = new Map();

    valuesMap.forEach((value, key) => {
      const column = columnMapById.get(key);
      // Skip read-only / non-importable columns
      if (
        !column ||
        !column.id ||
        (!column.columnDef.editable && !column.columnDef.importable)
      ) {
        return;
      }

      const { uploadFn } = column.columnDef;
      row.set(key, uploadFn ? uploadFn(value) : value);
    });

    if (identifierColumnId) {
      if (!valuesMap.has(identifierColumnId)) {
        throw new Error(
          `Identifier column ${identifierColumnId} not found in row ${i}`
        );
      }
    }

    /**
     * Use the identifier column as a key since this column is likely read-only
     * and won't be included in the values map
     */
    const rowKey = identifierColumnId ? valuesMap.get(identifierColumnId) : i;
    return [rowKey, row];
  });

  return new Map(mappedRows);
};

export const mapTableFlowColumns = (columns, identifierColumnId = false) =>
  columns
    .filter(
      (c) =>
        c.id === identifierColumnId ||
        ((c.columnDef.editable || c.columnDef.importable) && c.columnDef.schema)
    )
    .map((column) => {
      /** @typedef {import("yup").ObjectSchema} ObjectSchema */
      /** @type {ObjectSchema} */
      const columnSchema = column.columnDef.schema;
      const isIdentifierColumn = column.id === identifierColumnId;
      return {
        name: column.columnDef.header,
        key: column.id,
        data_type: columnSchema.type,
        required: identifierColumnId
          ? isIdentifierColumn
          : !columnSchema.spec.nullable,
        suggested_mappings: [column.columnDef.header],
      };
    });
